import { Component } from '@angular/core';
import { soundpostProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostproduct-form',
    templateUrl: './soundpostproduct.form.component.html'
})
export class soundpostProductFormComponent extends BaseFormComponent {
    public record!: soundpostProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'productGLAccounts', sectionName: 'Product GL Accounts', isExpanded: false },
            { sectionKey: 'orderLines', sectionName: 'Order Lines', isExpanded: false },
            { sectionKey: 'products', sectionName: 'Products', isExpanded: false },
            { sectionKey: 'revenueRecognitionRules', sectionName: 'Revenue Recognition Rules', isExpanded: false }
        ]);
    }
}

